// src/screens/ProfileScreen.jsx
import { useState } from "react";
import { C } from "../styles/tokens";
import { Icon, Badge } from "../components/UI";

const INITIAL_FORM = {
  name:  "City General Hospital",
  city:  "Vadodara, Gujarat",
  email: "bloodbank@cityhospital.in",
  phone: "+91 98765 43210",
  hours: "24/7",
  regNo: "HOS/GJ/2024/001",
  admin: "Dr. Rajesh Sharma",
};

const FIELDS = [
  { label: "Hospital Name",    key: "name",  icon: "hospital"  },
  { label: "City / Address",   key: "city",  icon: "location"  },
  { label: "Email Address",    key: "email", icon: "mail"      },
  { label: "Phone Number",     key: "phone", icon: "phone"     },
  { label: "Working Hours",    key: "hours", icon: "calendar"  },
  { label: "Registration No.", key: "regNo", icon: "stats"     },
  { label: "Admin Name",       key: "admin", icon: "person"    },
];

export default function ProfileScreen() {
  const [editing, setEditing] = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [form,    setForm]    = useState(INITIAL_FORM);

  const save = () => {
    setSaved(true);
    setEditing(false);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div className="fade-up" style={{ padding: 24, maxWidth: 680 }}>
      {/* Save toast */}
      {saved && (
        <div className="fade-in" style={{ background: "rgba(56,142,60,.12)", border: "1px solid rgba(56,142,60,.3)", borderRadius: 12, padding: "12px 18px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
          <Icon name="check" size={16} color="#4CAF50" />
          <span style={{ color: "#4CAF50", fontSize: 13, fontWeight: 600 }}>Profile saved successfully!</span>
        </div>
      )}

      {/* Header card */}
      <div className="card" style={{ padding: 28, marginBottom: 16, background: "linear-gradient(135deg, rgba(198,40,40,.12), rgba(198,40,40,.04))", border: "1px solid rgba(198,40,40,.2)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
          <div style={{ width: 72, height: 72, background: "rgba(198,40,40,.2)", borderRadius: 18, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon name="hospital" size={36} color={C.red} />
          </div>
          <div style={{ flex: 1 }}>
            <div className="syne" style={{ fontSize: 22, fontWeight: 900 }}>{form.name}</div>
            <div style={{ color: C.muted, fontSize: 13, marginTop: 4 }}>{form.city}</div>
            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <Badge label="✓ Verified Hospital" color={C.green} />
              <Badge label="Blood Bank Active"   color={C.blue}  />
            </div>
          </div>
          <button className="btn-sm" onClick={() => setEditing(!editing)}>
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="edit" size={13} color={C.red} />
              {editing ? "Cancel" : "Edit Profile"}
            </span>
          </button>
        </div>
      </div>

      {/* Quick stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 16 }}>
        {[["66", "Units In Stock"], ["12", "Active Requests"], ["38", "Nearby Donors"]].map(([v, l]) => (
          <div key={l} className="card" style={{ padding: 16, textAlign: "center" }}>
            <div className="syne" style={{ fontSize: 28, fontWeight: 900, color: C.red }}>{v}</div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Info form */}
      <div className="card" style={{ padding: 24 }}>
        <div className="syne" style={{ fontSize: 15, fontWeight: 800, marginBottom: 18 }}>Hospital Information</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {FIELDS.map((f) => (
            <div key={f.key}>
              <label className="inp-label">{f.label}</label>
              {editing ? (
                <div className="inp-wrap">
                  <span className="inp-icon"><Icon name={f.icon} size={14} color={C.red} /></span>
                  <input
                    className="inp"
                    value={form[f.key]}
                    onChange={(e) => setForm((p) => ({ ...p, [f.key]: e.target.value }))}
                  />
                </div>
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 14px", background: C.card2, borderRadius: 12, border: `1px solid ${C.border}` }}>
                  <Icon name={f.icon} size={14} color={C.red} />
                  <span style={{ fontSize: 14, color: C.text }}>{form[f.key]}</span>
                </div>
              )}
            </div>
          ))}
        </div>
        {editing && (
          <button className="btn-primary" style={{ marginTop: 20 }} onClick={save}>
            <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <Icon name="check" size={16} color="#fff" />Save Changes
            </span>
          </button>
        )}
      </div>

      {/* Account actions */}
      <div className="card" style={{ padding: 20, marginTop: 16, border: "1px solid rgba(211,47,47,.25)" }}>
        <div className="syne" style={{ fontSize: 14, fontWeight: 800, color: C.red, marginBottom: 12 }}>Account Actions</div>
        <div style={{ display: "flex", gap: 10 }}>
          <button className="btn-sm">Change Password</button>
          <button className="btn-sm" style={{ background: "rgba(211,47,47,.12)", color: C.red, borderColor: "rgba(211,47,47,.3)" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="logout" size={13} color={C.red} />Sign Out
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}